import UserModel from "../models/UserModel";

export default class ReconnectSinglePageController {
  private username: string = null;
  private baseReputationLevelUrl =
    process.env.IMAGES_URL +
    "custom-pages/reconnect-page-2023/reputation-levels/";
  private basePersonasCardsUrl =
    process.env.IMAGES_URL + "custom-pages/reconnect-page-2023/personas-cards/";
  private baseBadgesUrl =
    process.env.IMAGES_URL + "custom-pages/reconnect-page-2023/badges/";
  private badgeMap = [
    {
      rankID: 14,
      name: "Member",
      image: "Member",
      level: 0,
      points: 0,
      imageName: "",
      cssClass: "",
    },
    {
      rankID: 1,
      name: "Green Ribbon",
      image: "Green Ribbon",
      level: 1,
      points: 100,
      imageName: "Green Ribbon.svg",
      cssClass: "bg-greenRibbon",
    },
    {
      rankID: 2,
      name: "Red Ribbon",
      image: "Red Ribbon",
      level: 2,
      points: 250,
      imageName: "Red Ribbon.svg",
      cssClass: "bg-redRibbon",
    },
    {
      rankID: 3,
      name: "Blue Ribbon",
      image: "Blue Ribbon",
      level: 3,
      points: 750,
      imageName: "Blue Ribbon.svg",
      cssClass: "bg-blueRibbon",
    },
    {
      rankID: 4,
      name: "Bronze Medal",
      image: "Bronze Medal",
      level: 4,
      points: 1250,
      imageName: "Bronze Medal.svg",
      cssClass: "bg-bronze",
    },
    {
      rankID: 5,
      name: "Silver Medal",
      image: "Silver Medal",
      level: 5,
      points: 2000,
      imageName: "Silver Medal.svg",
      cssClass: "bg-silver",
    },
    {
      rankID: 6,
      name: "Gold Medal",
      image: "Gold Medal",
      level: 6,
      points: 3500,
      imageName: "Gold Medal.svg",
      cssClass: "bg-gold",
    },
    {
      rankID: 7,
      name: "Bronze Trophy",
      image: "Bronze Trophy",
      level: 7,
      points: 5000,
      imageName: "Bronze Trophy.svg",
      cssClass: "bg-bronze",
    },
    {
      rankID: 8,
      name: "Silver Trophy",
      image: "Silver Trophy",
      level: 8,
      points: 7500,
      imageName: "Silver Trophy.svg",
      cssClass: "bg-silver",
    },
    {
      rankID: 9,
      name: "Gold Trophy",
      image: "Gold Trophy",
      level: 9,
      points: 10000,
      imageName: "Gold Trophy.svg",
      cssClass: "bg-gold",
    },
    {
      rankID: 10,
      name: "Bronze Crown",
      image: "Bronze Crown",
      level: 10,
      points: 15000,
      imageName: "Bronze Crown.svg",
      cssClass: "bg-bronze",
    },
    {
      rankID: 11,
      name: "Silver Crown",
      image: "Silver Crown",
      level: 11,
      points: 22500,
      imageName: "Silver Crown.svg",
      cssClass: "bg-silver",
    },
    {
      rankID: 12,
      name: "Gold Crown",
      image: "Gold Crown",
      level: 12,
      points: 30000,
      imageName: "Gold Crown.svg",
      cssClass: "bg-gold",
    },
    {
      rankID: 13,
      name: "Diamond",
      image: "Diamond",
      level: 13,
      points: 60000,
      imageName: "Diamond.svg",
      cssClass: "bg-diamond",
    },
    {
      rankID: 15,
      name: "Jadeite",
      image: "Jadeite",
      level: 14,
      points: 120000,
      imageName: "Jadeite.svg",
      cssClass: "bg-greenRibbon",
    },
    {
      rankID: 16,
      name: "Rubellite",
      image: "Rubellite",
      level: 15,
      points: 200000,
      imageName: "Rubellite.svg",
      cssClass: "bg-redRibbon",
    },
    {
      rankID: 17,
      name: "Tanzanite",
      image: "Tanzanite",
      level: 16,
      points: 300000,
      imageName: "Tanzanite.svg",
      cssClass: "bg-blueRibbon",
    },
  ];
  private personasMap = [
    {
      badgeId: 448,
      name: "The Traveler",
      description1:
        "Your online travels have brought you to the Cloud Customer Connect Community, but you still aren't sure what we are all about. If you are interested in finding out more, exploring what the Community has to offer, and becoming a more active member in the future, welcome aboard!",
      description2:
        "We are glad you're here, and look forward to providing answers, guidance, and information to you as a newer Community member.",
      cardImageName: "Section5-TravelerCard.png",
      badgeImageName: "Traveler.svg",
    },
    {
      badgeId: 447,
      name: "The Observer",
      description1:
        "As The Observer, you have visited the Community, and for the moment, you are content to quietly observe and take in information. So far, you have limited engagement and interaction, but we know you are there and we want to support you!",
      description2:
        "We are looking forward to your contributions when you feel comfortable reaching out and discovering more of what the Community has to offer.",
      cardImageName: "Section5-ObserverCard.png",
      badgeImageName: "Observer.svg",
    },
    {
      badgeId: 454,
      name: "The Collector",
      description1:
        "As The Collector, you have visited the Community and started your journey as an active member. You've discovered areas of interest and seen ways in which the Community can help and inform its members.",
      description2:
        'You\'ve "followed" categories, events and ideas. You are poised to reach new levels of success through knowledge-sharing and Community involvement!',
      cardImageName: "Section5-CollectorCard.png",
      badgeImageName: "Collector.svg",
    },
    {
      badgeId: 449,
      name: "The Inquisitor",
      description1:
        "As The Inquisitor, you have actively reached out to other members, asking questions, initiating discussions, and building relationships.",
      description2:
        "You've discovered how supportive and helpful the Community can be, but this is just the beginning! Your quest for knowledge and your thirst for new adventures will lead you down an exciting pathway.",
      cardImageName: "Section5-InquisitorCard.png",
      badgeImageName: "Inquisitor.svg",
    },
    {
      badgeId: 450,
      name: "The Innovator",
      description1:
        "As The Innovator, your creativity is shining through! You contribute to the Community through ideas that will make Oracle products and designs better, more effective, and more efficient.",
      description2:
        "You've also analyzed others' ideas and you love thinking, tinkering, and figuring out the whats, whys and how-tos. Other members look to you for inspiration and can't wait to see what you'll come up with next!",
      cardImageName: "Section5-InnovatorCard.png",
      badgeImageName: "Innovator.svg",
    },
    {
      badgeId: 451,
      name: "The Sage",
      description1:
        "As The Sage, you are seeking answers to technical concerns - and you know the Community is where you'll find them.",
      description2:
        "You have combed through the site for product information and solutions. You are able to (almost magically) access the information you need to clarify confusing issues and solve vexing problems.",
      cardImageName: "Section5-SageCard.png",
      badgeImageName: "Sage.svg",
    },
    {
      badgeId: 452,
      name: "The Scholar",
      description1:
        "As The Scholar, you are a seeker of knowledge, a lover of information and a connoisseur of Community activity. From attending training sessions and events to engaging with other members through questions and discussion, you wish to gain insights, inspiration, and solutions. In turn, you share what you've learned with other members.",
      description2:
        "We look forward to your continued commitment to learning and growth within the Community!",
      cardImageName: "Section5-ScholarCard.png",
      badgeImageName: "Scholar.svg",
    },
    {
      badgeId: 453,
      name: "The Rockstar",
      description1:
        "Congratulations! You are a true Community Rockstar, and you've proven yourself through the badges you've earned, the levels you've achieved and the points you've gained.",
      description2:
        "From the Leaderboard to our monthly theme list, your Community star is shining brightly. We can't wait to see what stellar achievements are yet to come!",
      cardImageName: "Section5-RockstarCard.png",
      badgeImageName: "Rockstar.svg",
    },
  ];

  /**
   * Gets the current username and displays the proper welcome message in the DOM based on the CSS selector received as parameter.
   * @param selector CSS selector for HTML element to display welcome message.
   */
  public async updateTitle(selector: string): Promise<void> {
    try {
      const titleElement = document.querySelector(selector);
      // Get current user.
      const currentUser = await UserModel.getCurrentUserCached();
      // Display username if it's valid.
      const firstName = this.getFirstName(currentUser.name);
      this.username = this.validUsername(firstName) ? firstName : null;
      if (titleElement) {
        if (this.username) {
          titleElement.innerHTML = titleElement.innerHTML.replace(
            "[username]",
            this.username
          );
        } else {
          titleElement.innerHTML = titleElement.innerHTML.replace(
            "[username]",
            ""
          );
        }
      } else {
        console.error(`Reconnect - ${selector} element not found in DOM`);
      }
    } catch (error) {
      console.error(error);
    }
  }

  private getFirstName(username: string): string {
    const firstName = username.match(/^[A-Z]+/gim);
    if (firstName.length > 0) {
      return firstName[0];
    }
    return null;
  }

  private validUsername(username: string): boolean {
    if (username.toLowerCase().match(/user/gim)) {
      return false;
    }
    return true;
  }

  /**
   * Gets current user level and updates the feedback section on the page.
   * @param levelTitleSelector
   * @param levelDescriptionSelector
   * @param imageSelector
   * @param sectionSelector
   */
  public async updateFeedbackSection(
    levelTitleSelector: string,
    levelDescriptionSelector: string,
    imageSelector: string,
    sectionSelector: string = null
  ): Promise<void> {
    try {
      const levelTitleElement = document.querySelector(levelTitleSelector);
      const levelDescriptionElement = document.querySelector(
        levelDescriptionSelector
      );
      // Get current user.
      const user = await UserModel.getCurrentUserCached();
      // Update level name.
      if (
        levelTitleElement &&
        levelDescriptionElement &&
        user?.currentRank?.name
      ) {
        let title = "";
        let description = "";
        // Set section content.
        console.debug("Reconnect - User:", user);
        if (user.currentRank.level === 0) {
          // First level.
          const points = this.badgeMap[1].points - user.points;
          title = "Feel inspired[, username]?";
          description =
            "People like you make our community a special place. You're just " +
            points.toLocaleString() +
            " points away from earning a " +
            this.badgeMap[1].name +
            ". <strong>Join the conversation and start earning points.</strong>";
        } else if (!this.badgeMap[user.currentRank.level + 1]) {
          // Last level.
          title = "Keep shining bright[, username]!";
          description =
            "Thanks to your contributions, you've earned the " +
            user.currentRank.name +
            " badge. That means you're <strong>one of a kind, the best of the best.</string>";
        } else {
          // Between 2nd and last but one level.
          const points =
            this.badgeMap[user.currentRank.level + 1].points - user.points;
          title = "You're amazing[, username]!";
          description =
            "Congratulations on earning a " +
            user.currentRank.name +
            ". You're just " +
            points.toLocaleString() +
            " points away from leveling up to the coveted " +
            this.badgeMap[user.currentRank.level + 1].name +
            ". <strong>Join the conversation.</strong>";
        }
        // Display username if user has a valid one.
        if (this.username) {
          title = title.replace("[, username]", ", " + this.username);
        } else {
          title = title.replace("[, username]", "");
        }
        levelTitleElement.innerHTML = title;
        levelDescriptionElement.innerHTML = description;
        // Set badge image.
        const imageElement = document.querySelector(imageSelector);
        const imageName =
          user.currentRank.level === 0
            ? this.badgeMap[1].imageName
            : this.badgeMap[user.currentRank.level].imageName;
        imageElement.setAttribute(
          "src",
          this.baseReputationLevelUrl + imageName
        );
        // Set background.
        const sectionElement = document.querySelector(sectionSelector);
        const sectionCssClass =
          user.currentRank.level === 0
            ? this.badgeMap[1].cssClass
            : this.badgeMap[user.currentRank.level].cssClass;
        sectionElement.classList.add(sectionCssClass);
      } else {
        throw `${levelTitleSelector} or ${levelDescriptionSelector} not found in DOM`;
      }
    } catch (error) {
      console.error(error);
    }
  }

  /**
   * Gets current user level and updates the persona sections on the page.
   * @param personaNameSelector
   * @param personaDescription1Selector
   * @param personaDescription2Selector
   * @param cardImageSelector
   * @param badgeImageSelector
   */
  public async updatePersonaSection(
    personaNameSelector: string,
    personaDescription1Selector: string,
    personaDescription2Selector: string,
    cardImageSelector: string,
    badgeImageSelector: string
  ): Promise<void> {
    try {
      const $personaNameElement = document.querySelector(personaNameSelector);
      const $personaDescription1Element = document.querySelector(
        personaDescription1Selector
      );
      const $personaDescription2Element = document.querySelector(
        personaDescription2Selector
      );
      const $personaCardElement = document.querySelector(cardImageSelector);
      const $badgeElement = document.querySelector(badgeImageSelector);

      // Get current user.
      const user = await UserModel.getCurrentUserCached();
      // Get user badges.
      const badges = await UserModel.getUserBadges(user.id);
      // Know which persona badge will be displayed.
      const persona = this.personasMap
        .reverse()
        .find((persona) =>
          badges.find((badge) => persona.badgeId === badge.badgeID)
        );
      // Update UI
      if (persona) {
        $personaNameElement.innerHTML = persona.name;
        $personaDescription1Element.innerHTML = persona.description1;
        $personaDescription2Element.innerHTML = persona.description2;
        $personaCardElement.setAttribute(
          "src",
          this.basePersonasCardsUrl + persona.cardImageName
        );
        $badgeElement.setAttribute(
          "src",
          this.baseBadgesUrl + persona.badgeImageName
        );
      }
    } catch (error) {
      console.error(error);
    }
  }

  /**
   * Append an iframe to the dom to register user visit.
   */
  public async registerUserVisit(): Promise<void> {
    // Get current user from cache.
    const currentUser = await UserModel.getCurrentUserCached();
    // Construct URL to use in iframe.
    const searchParams = new URLSearchParams();
    searchParams.append("visit", currentUser.id.toString());
    const url = new URL(
      process.env.VANILLA_COMMUNITY_URL + "categories/reconnect-adobe-report"
    );
    url.search = new URLSearchParams(searchParams).toString();
    // Create iframe to register user visit with Adobe Analytics.
    const iframe = document.createElement("iframe");
    iframe.style.display = "none";
    iframe.setAttribute("src", url.toString());
    // Append iframe to body.
    const body = document.querySelector("body");
    body.appendChild(iframe);
  }

  /**
   * Hides the initial loader and display the main content.
   * @param loaderSelector CSS selector for the loader.
   * @param contentSelector CSS selector for the content to display.
   */
  public displayPageContent(
    loaderSelector: string,
    contentSelector: string
  ): void {
    const loaderElement = document.querySelector(loaderSelector);
    const contentElement = document.querySelector(contentSelector);
    if (loaderElement && contentElement) {
      loaderElement.classList.add("reconnect-section-hidden");
      loaderElement.addEventListener("transitionend", function () {
        loaderElement.classList.add("hidden");
        contentElement.classList.remove("hidden");
        setTimeout(() => {
          contentElement.classList.remove("reconnect-section-hidden");
        }, 1);
      });
    }
  }
}
